import type { HttpPost } from '@/shared/infra/http'
import { HttpError } from '@/shared/infra/http'
import { DuplicateContactError, InvalidOtpError } from '@/shared/domain'
import type { ClaimContact, ClaimContactParams } from '@/modules/auth/use-cases'

type VerifyIdentifierBody = {
  identifier: string
  identifierType: 'email' | 'phone'
  code: string
}

export class EdgeClaimContactRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: ClaimContact = async (params: ClaimContactParams) => {
    try {
      await this.httpClient.post<VerifyIdentifierBody, unknown>({
        url: '/users/verify-identifier',
        body: {
          identifier: params.identifier,
          identifierType: params.identifierType,
          code: params.code,
        },
      })
    } catch (error) {
      if (error instanceof HttpError && error.status === 400) {
        throw new InvalidOtpError()
      }
      if (error instanceof HttpError && error.status === 409) {
        throw new DuplicateContactError(
          'This contact is verified on another account and cannot be claimed.',
        )
      }
      throw error
    }
  }
}
